var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bookmark-cascader"
  }, [_c('div', {
    staticClass: "tree-btn clearfix"
  }, [_c('div', {
    staticClass: "maxlength f_left"
  }, [_vm._v(_vm._s(_vm.$t('lang.Bookmark')))]), _vm.checkValue.length ? _c('div', {
    staticClass: "f_left num click-hide"
  }, [_vm._v("(" + _vm._s(_vm.bookmarkLength) + ")")]) : _vm._e(), _c('i', {
    class: [_vm.visibleStatus ? 'el-icon-arrow-up' : 'el-icon-arrow-top']
  })]), _vm.fromPage == 'bk' ? _c('el-cascader-panel', {
    ref: "bookmark",
    attrs: {
      "options": _vm.bookmarkList,
      "props": _vm.cascaderProps,
      "collapse-tags": "",
      "popper-class": "bookmarkList-cascader-panel"
    },
    on: {
      "change": _vm.handleChange,
      "visible-change": _vm.visibleChange
    },
    model: {
      value: _vm.checkValue,
      callback: function ($$v) {
        _vm.checkValue = $$v;
      },
      expression: "checkValue"
    }
  }) : _c('el-cascader', {
    ref: "bookmark",
    attrs: {
      "options": _vm.bookmarkList,
      "props": _vm.cascaderProps,
      "collapse-tags": "",
      "popper-class": _vm.fromPage == 'al' ? 'bookmarkList-cascader bookmarkList-cascader-al' : 'bookmarkList-cascader'
    },
    on: {
      "change": _vm.handleChange,
      "visible-change": _vm.visibleChange,
      "blur": _vm.hideCascader
    },
    model: {
      value: _vm.checkValue,
      callback: function ($$v) {
        _vm.checkValue = $$v;
      },
      expression: "checkValue"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }